import {
  PermissionRouteGuard,
  type PermissionRouteGuardData,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QuestionCreationTaskDetailsModalProvider,
  QuestionCreationTaskDetailsProvider,
} from '@exam-management/question-creation-task-details';
import { useParams } from '@exam-management/router';
import { TaskManagementPermissionRoute } from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function QuestionCreationLayout() {
  const { taskId } = useParams('/task-management/question-creation/:taskId');

  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/task-management/question-creation/:taskId',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/details',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/question-list',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/single/create',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.CREATE],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/single/:questionId',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/item-set/:questionId',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/item-set/:questionId/:subQuestionId',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <TaskManagementPermissionRoute taskId={taskId}>
        <QuestionCreationTaskDetailsProvider taskId={taskId}>
          <QuestionCreationTaskDetailsModalProvider>
            <Outlet />
          </QuestionCreationTaskDetailsModalProvider>
        </QuestionCreationTaskDetailsProvider>
      </TaskManagementPermissionRoute>
    </PermissionRouteGuard>
  );
}
